module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/playerHeadshots/nfl/new_survive-642b2416d5adef4b1a0b88c9a39cc22c.svg";